import _ from 'lodash';
import { currentLanguage } from '../i18n';

const getProductDescriptionsByNr = (context) => _.get(context, 'entities.productDescriptions') || {};

export const getProductDescriptionForProduct = (context, product) => {
  if (!product) {
    return null;
  }
  const productDescriptions = getProductDescriptionsByNr(context);
  const language = currentLanguage() || 'de';
  const productDescription = productDescriptions[product.number] || {};

  return productDescription[language] || {};
};
